import React, { createContext, useContext, useState, useEffect } from 'react';
import { ThemeProvider } from '@mui/material/styles';
import themes from '../theme/themes';

const ThemeContext = createContext();

export function useTheme() {
  return useContext(ThemeContext);
}

export function CustomThemeProvider({ children }) {
  const [currentTheme, setCurrentTheme] = useState('pastelGreen');

  // ローカルストレージからテーマを読み込み
  useEffect(() => {
    const savedTheme = localStorage.getItem('selectedTheme');
    if (savedTheme && themes[savedTheme]) {
      setCurrentTheme(savedTheme);
    }
  }, []);

  // テーマ変更時にローカルストレージに保存
  const changeTheme = (themeName) => {
    if (themes[themeName]) {
      setCurrentTheme(themeName);
      localStorage.setItem('selectedTheme', themeName);
    }
  };

  const value = {
    currentTheme,
    changeTheme,
    availableThemes: Object.keys(themes),
    themeNames: {
      pastelGreen: 'パステルグリーン',
      softBlue: 'ソフトブルー',
      warmPink: 'ウォームピンク',
      midnight: 'ミッドナイト',
    },
  };

  return (
    <ThemeContext.Provider value={value}>
      <ThemeProvider theme={themes[currentTheme]}>
        {children}
      </ThemeProvider>
    </ThemeContext.Provider>
  );
}